.service-calls-dynamic-input {
    display: block;
    position: relative;

    .service-calls-dynamic-input__dynamic-container.is-min-reached {
        ux-icon {
            opacity: 0.3;
            cursor: default;
        }
    }

    .service-calls-dynamic-input__input-container {
        display: flex;
        align-items: center;
        margin: 0 0 10px;

        ux-icon {
            margin: 0 0 0 20px;
            opacity: 1;
            cursor: pointer;
            transition: opacity 0.2s ease-in-out;
        }
    }

    .ux-text-link {
        display: inline-block;
        cursor: pointer;
        transition: color 0.2s ease-in-out;

        &.is-max-reached {
            color: #a6a6a6;
            cursor: default;
        }
    }
}
